import api from '../httpClient';

export interface FaqItem {
  id: number;
  title: string;
  content: string;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export interface FaqDraftItem {
  id?: number;
  title: string;
  content: string;
  display_order?: number;
}

export const faq = {
  list: () => api.get<FaqItem[]>('/api/faqs/'),
  admin: {
    list: () => api.get<FaqItem[]>('/api/admin/faqs/'),
    create: (payload: FaqDraftItem) => api.post<FaqItem>('/api/admin/faqs/', payload),
    update: (id: number, payload: Partial<FaqDraftItem>) =>
      api.patch<FaqItem>(`/api/admin/faqs/${id}/`, payload),
    delete: (id: number) => api.delete(`/api/admin/faqs/${id}/`),
    bulkSave: (items: FaqDraftItem[]) =>
      api.post<FaqItem[]>('/api/admin/faqs/bulk-save/', { items }),
  },
};

